import wx from 'weixin-js-sdk'
/**
 * 判断是否是支付宝
 */
export function isMiniApplets() {
    let userAgent = navigator
        .userAgent
        .toLowerCase();
    //判断是否是支付宝
    if (userAgent.match(/Alipay/i) == "alipay") {
        return 'alipay';
    } else if (userAgent.match(/MicroMessenger/i) == "micromessenger") { //微信判断
        return 'wechat';
    } else if (userAgent.match(/elmc/i)) {
        return 'eleme';
    } else {
        return false;
    }
}

/**
 * 是否是小程序环境
 */
export function isMiNiProgram() {

    return new Promise((resolve, reject) => {
        wx.miniProgram.getEnv(function (res) {
            console.log(`当前小程序环境-----》${res.miniprogram}`);
            resolve(res.miniprogram);
        });
    })
}
/**
 * h5页面打开环境
 */
export function isEquipment() {
    let UA = navigator.userAgent,
        isAndroid = /android|adr|linux/gi.test(UA),
        isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid,
        isBlackBerry = /BlackBerry/i.test(UA),
        isWindowPhone = /IEMobile/i.test(UA),
        isMobile = isAndroid || isIOS || isBlackBerry || isWindowPhone;
    return {
        isAndroid: isAndroid,
        isIOS: isIOS,
        isMobile: isMobile,
        isWeixin: /MicroMessenger/gi.test(UA),
        isQQ: /QQ/gi.test(UA),
        isPC: !isMobile,
        isWeibo: /WeiBo/gi.test(UA)
    }
}
/**
 * 版本比较
 * @param {*} version
 * @param {*} minVersion
 */
export function versionfunegt(version, minVersion) {
    var original = version.split("."),
        min = minVersion.split(".");
    if (parseInt(original[0]) > parseInt(min[0])) {
        return true;
    } else if (parseInt(original[1]) > parseInt(min[1])) {
        return true;
    } else if (parseInt(original[2]) >= parseInt(min[2])) {
        return true;
    } else {
        return false;
    }
}
